/**
 * Helper function for health & safety icon state-based colors
 * @param {string|null} state - Asset state ('available', 'locked_out', etc.)
 * @returns {object} Color configuration for pin, ring, and icon
 */
export const getStateColors = (state) => {
  switch(state) {
    case 'locked_out':
      return {
        pinColor: '#0B2A1B',    // Dark green
        ringColor: '#ef4444',   // Red
        iconColor: '#E53E3E'    // Red icon
      };
    case 'available':
      return {
        pinColor: '#0B2A1B',    // Dark green
        ringColor: 'white',
        iconColor: '#E53E3E'    // Red icon
      };
    default:
      // Default to available/green for any unknown state
      return {
        pinColor: '#0B2A1B',
        ringColor: 'white',
        iconColor: '#E53E3E'    // Red icon
      };
  }
};
